import React, { useState,useEffect } from "react";
import { firestore } from "../../Config/firebase"; // Adjust the import path based on your project structure
import { addDoc, collection, doc, query,where,getDocs, updateDoc,deleteDoc } from "firebase/firestore";
import "./styles.scss";

function ReservationForm({
  selectedRoom,
  closeForm,
  floor,
  getAllReservations,
  changeAlertMakerContent,
  userName,
  editForm,
  closeDetails,
  resetEditForm
}) {
  const [typeOfRoom, setTypeOfRoom] = useState("");

  // Resident 1 Details
  const [name1, setName1] = useState("");
  const [resp1,setResp1] = useState("")
  const [rate1, setRate1] = useState("");
  const [deposit1, setDeposit1] = useState("");
  const [startDate1, setStartDate1] = useState("");
  const [bed1, setBed1] = useState("");
  const [contact1,setContact1] = useState("")
  const [notes1, setNotes1] = useState("");

  // Person 2 Details (for Semi Private rooms)
  const [name2, setName2] = useState("");
  const [resp2,setResp2] = useState("")
  const [rate2, setRate2] = useState("");
  const [deposit2, setDeposit2] = useState("");
  const [startDate2, setStartDate2] = useState("");
  const [bed2, setBed2] = useState("");
  const [contact2,setContact2] = useState("")
  const [notes2, setNotes2] = useState("");



  // Fetch the current reservation details
  useEffect(() => {
    const fetchReservationDetails = async () => {
      if (editForm) {
        try {
            // Query the reservations collection for the specific room number
        const reservationsCollection = collection(firestore, "reservations");
        const q = query(reservationsCollection, where("room", "==", selectedRoom));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const reservationDoc = querySnapshot.docs[0];
          const data = reservationDoc.data();
          
            setTypeOfRoom(data.typeOfRoom || "");
            setName1(data.person1?.name || "");
            setResp1(data.person1?.resp || "");
            setContact1(data.person1?.contact || "");
            setRate1(data.person1?.rate || "");
            setDeposit1(data.person1?.deposit || "");
            setStartDate1(data.person1?.startDate || "");
            setBed1(data.person1?.bed || "");
            setNotes1(data.person1?.notes || "");

            if (data.person2) {
              setName2(data.person2.name || "");
              setResp2(data.person2?.resp || "");
              setContact2(data.person2.contact || "");
              setRate2(data.person2.rate || "");
              setDeposit2(data.person2.deposit || "");
              setStartDate2(data.person2.startDate || "");
              setBed2(data.person2.bed || "");
              setNotes2(data.person2.notes || "");
            }
          }
        } catch (error) {
          console.error("Error fetching reservation details:", error);
        }
      }
    };

    fetchReservationDetails();
  }, [editForm]);

 // Handle form submission
 const handleSubmit = async (e) => {
  e.preventDefault();
var resident2Verified = validateResident2(e)
if(resident2Verified){
  const reservationData = {
    typeOfRoom,
    room: selectedRoom,
    floor,
    userName,
    editDate: new Date().toISOString(),
    person1: {
      name: name1,
      resp:resp1,
      contact: contact1,
      rate: rate1,
      deposit: deposit1,
      startDate: startDate1,
      bed: bed1,
      notes: notes1,
    },
    person2: typeOfRoom.includes("Semi Private")
      ? {
          name: name2,
          resp:resp2,
          contact: contact2,
          rate: rate2,
          deposit: deposit2,
          startDate: startDate2,
          bed: bed2,
          notes: notes2,
        }
      : null,
  };

  try {
    if (editForm) {
      // Query the reservations collection for the specific room number
      const reservationsCollection = collection(firestore, "reservations");
      const q = query(reservationsCollection, where("room", "==", selectedRoom));
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        // Assuming there is only one reservation for a room
        const reservationDoc = querySnapshot.docs[0].ref;
  
        // Update the reservation
        await updateDoc(reservationDoc, reservationData);
  
        changeAlertMakerContent(`Room No ${selectedRoom} successfully modified!`);
        closeDetails()
      }
      else {
        changeAlertMakerContent(`No reservation found for Room No ${selectedRoom}`);
      }
    }
     else {
      // Add new reservation
      const reservationsCollection = collection(firestore, "reservations");
      await addDoc(reservationsCollection, reservationData);
      changeAlertMakerContent(`Room No ${selectedRoom} successfully reserved!`);
    }
    resetEditForm()
    getAllReservations();
    closeForm();
  } catch (error) {
    console.error("Error submitting reservation:", error);
    alert("Failed to submit the reservation. Please try again.");
  }
}
};

const validateResident2 = (e) => {
  e.preventDefault();

  const anyFieldFilled =
    name2 || resp2 || contact2 || rate2 || deposit2;

  const allFieldsFilled =
    name2 && resp2 && contact2 && rate2 && deposit2 && startDate2 && bed2;

  if (typeOfRoom.includes("Semi Private")) {
    if (anyFieldFilled && !allFieldsFilled) {
      // Dynamically make required those that are empty
      const form = e.target;
      if (!name2) document.getElementById("name2").required = true;
      if (!resp2) document.getElementById("resp2").required = true;
      if (!contact2) document.getElementById("contact2").required = true;
      if (!rate2) document.getElementById("rate2").required = true;
      if (!deposit2) document.getElementById("deposit2").required = true;
      if (!startDate2) document.getElementById("startDate2").required = true;
      if (!bed2) document.getElementById("bed2").required = true;

      // Trigger native validation
      form.reportValidity();
      return false;
    }
  }

  return true

};


async function relinquishRoom(){
  try {
      // Query Firestore to find the document(s) with the matching attribute value
      const q = query(
          collection(firestore, "reservations"),
          where("room", "==", selectedRoom)
      );

      // Get matching documents
      const querySnapshot = await getDocs(q);

      // Loop through each document and delete it
      querySnapshot.forEach(async (docSnap) => {
          const docRef = doc(firestore, "reservations", docSnap.id);
          await deleteDoc(docRef);
          closeForm();
          closeDetails()
          getAllReservations()
          resetEditForm()

          changeAlertMakerContent(`Room No ${selectedRoom} successfully relinquished!`)
      });

      if (querySnapshot.empty) {
        resetEditForm()
          console.log("No matching documents found.");
      }
  } catch (error) {
      console.error("Error deleting document:", error);
  }
}




  return (
    <div className="reservation-form-root">
      <div className="reservation-form">
      <svg viewBox="0,0,256,256" width="24px" height="24px" fill-rule="nonzero" className="cross" onClick={()=>{closeForm();resetEditForm()}}><g fill="#5b2706">
                    <g transform="scale(10.66667,10.66667)">
                        <path d="M4.99023,3.99023c-0.40692,0.00011 -0.77321,0.24676 -0.92633,0.62377c-0.15312,0.37701 -0.06255,0.80921 0.22907,1.09303l6.29297,6.29297l-6.29297,6.29297c-0.26124,0.25082 -0.36647,0.62327 -0.27511,0.97371c0.09136,0.35044 0.36503,0.62411 0.71547,0.71547c0.35044,0.09136 0.72289,-0.01388 0.97371,-0.27511l6.29297,-6.29297l6.29297,6.29297c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-6.29297,-6.29297l6.29297,-6.29297c0.29576,-0.28749 0.38469,-0.72707 0.22393,-1.10691c-0.16075,-0.37985 -0.53821,-0.62204 -0.9505,-0.60988c-0.2598,0.00774 -0.50638,0.11632 -0.6875,0.30273l-6.29297,6.29297l-6.29297,-6.29297c-0.18827,-0.19353 -0.4468,-0.30272 -0.7168,-0.30273z">
                        </path>
                    </g>
                </g>
                </svg>
        <h2 className="reserve-title">Reservation Details</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-line">
          <div className="form-group">
            {/* <label htmlFor="type" className="form-label">
              Type of Room
            </label> */}
            <select
              id="type"
              required
              className="form-input"
              value={typeOfRoom}
              onChange={(e) => setTypeOfRoom(e.target.value)}
              style={{
                color: typeOfRoom === "" ? "#9f9379" : "#894018", // Change color based on selected value
                border: typeOfRoom === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value

              }}
            >
               <option className="type-of-heading" value="" disabled selected>Type of Room</option>
              <option className="option" value="Private">Private</option>
              <option className="option" value="Semi Private">Semi Private</option>
            </select>
          </div>
          </div>
          

          {/* Resident 1 Details */}
          {typeOfRoom.includes("Semi Private") && <h4 className="person-heading">Resident 1</h4>}
          <div className="form-line">
          <div className="form-group">
            {/* <label className="form-label">Name</label> */}
            <input
              type="text"
              required
              placeholder="Name"
              className="form-input"
              value={name1}
              onChange={(e) => setName1(e.target.value)}
              style={{
                border: name1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          <div className="form-group">
            {/* <label className="form-label">Name</label> */}
            <input
              type="text"
              required
              placeholder="Responsible Party"
              className="form-input"
              value={resp1}
              onChange={(e) => setResp1(e.target.value)}
              style={{
                border: resp1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          </div>

          <div className="form-line">
          <div className="form-group">
            {/* <label className="form-label">Contact</label> */}
            <input
              type="number"
              placeholder="Contact Number"
              required
              className="form-input"
              value={contact1}
              onChange={(e) => setContact1(e.target.value)}
              style={{
                border: contact1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          <div className="form-group">
            {/* <label className="form-label">Rate</label> */}
            <input
              type="number"
              placeholder="Room Rate"
              required
              className="form-input"
              value={rate1}
              onChange={(e) => setRate1(e.target.value)}
              style={{
                border: rate1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          
          </div>


          <div className="form-line">
          <div className="form-group">
            {/* <label className="form-label">Deposit</label> */}
            <input
              type="number"
              placeholder="Deposit"
              required
              className="form-input"
              value={deposit1}
              onChange={(e) => setDeposit1(e.target.value)}
              style={{
                border: deposit1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          <div className="form-group">
            {/* <label className="form-label">Start Date</label> */}
            <input
              type="date"
              placeholder="Welcome Date"
              required
              className="form-input"
              value={startDate1}
              style={{
                color: startDate1 === "" ? "#9f9379" : "#894018", // Change color based on selected value
                border: startDate1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              onChange={(e) => setStartDate1(e.target.value)}
            />
          </div>

          
          </div>

          <div className="form-line">
          {typeOfRoom.includes("Semi Private") && <div className="form-group">
            {/* <label className="form-label">Bed</label> */}
             <select
              id="type"
              required
              className="form-input"
              value={bed1}
              style={{
                color: bed1 === "" ? "#9f9379" : "#894018", // Change color based on selected value
                border: bed1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              onChange={(e) => setBed1(e.target.value)}
            >
              <option className="type-of-heading" value="" disabled selected>Bed</option>
              <option value="A">A</option>
              <option value="B">B</option>
            </select>
          </div>}
         
          <div className="form-group">
            {/* <label className="form-label">Notes</label> */}
            <input
              type="text"
              className="form-input"
              placeholder="Notes"
              value={notes1}
              onChange={(e) => setNotes1(e.target.value)}
              style={{
                border: notes1 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          </div>

          {/* Person 2 Details (conditionally rendered) */}
          {typeOfRoom.includes("Semi Private") && (
            <>
              <h3 className="person-heading">Resident 2</h3>
              <div className="form-line">
              <div className="form-group">
            {/* <label className="form-label">Name</label> */}
            <input
              type="text"
              placeholder="Name"
              className="form-input"
              id="name2"
              value={name2}
              onChange={(e) => setName2(e.target.value)}
              style={{
                border: name2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          <div className="form-group">
            {/* <label className="form-label">Name</label> */}
            <input
              type="text"
              placeholder="Responsible Party"
              className="form-input"
              value={resp2}
              id="resp2"
              style={{
                border: resp2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              onChange={(e) => setResp2(e.target.value)}
            />
          </div>
         
          </div>

          <div className="form-line">
          <div className="form-group">
            {/* <label className="form-label">Contact</label> */}
            <input
              type="number"
              placeholder="Contact Number"
              className="form-input"
              value={contact2}
              id="contact2"
              onChange={(e) => setContact2(e.target.value)}
              style={{
                border: contact2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
            />
          </div>
          <div className="form-group">
            {/* <label className="form-label">Rate</label> */}
            <input
              type="number"
              placeholder="Room Rate"
              className="form-input"
              value={rate2}
              style={{
                border: rate2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              id="rate2"
              onChange={(e) => setRate2(e.target.value)}
            />
          </div>
          </div>


          <div className="form-line">
          <div className="form-group">
            {/* <label className="form-label">Deposit</label> */}
            <input
              type="number"
              placeholder="Deposit"
              className="form-input"
               id="deposit2"
              value={deposit2}
              style={{
                border: deposit2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              onChange={(e) => setDeposit2(e.target.value)}
            />
          </div>
          <div className="form-group">
            {/* <label className="form-label">Start Date</label> */}
            <input
              type="date"
              placeholder="Welcome Date"
              className="form-input"
              value={startDate2}
              id="startDate2"
              style={{
                color: startDate2 === "" ? "#9f9379" : "#894018", // Change color based on selected value
                border: startDate2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              onChange={(e) => setStartDate2(e.target.value)}
            />
          </div>

        
          </div>
          <div className="form-line">
          <div className="form-group">
            {/* <label className="form-label">Bed</label> */}
             <select
              id="bed2"
              className="form-input"
              value={bed2}
              style={{
                color: bed2 === "" ? "#9f9379" : "#894018", // Change color based on selected value
                border: bed2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              onChange={(e) => setBed2(e.target.value)}
            >
              <option className="type-of-heading" value="" disabled selected>Bed</option>
              <option value="A">A</option>
              <option value="B">B</option>
            </select>
          </div>
          <div className="form-group">
            {/* <label className="form-label">Notes</label> */}
            <input
              type="text"
              className="form-input"
              placeholder="Notes"
              value={notes2}
              style={{
                border: notes2 === "" ? "1px solid #9f9379" : "1px solid #d1d5db", // Change color based on selected value
              }}
              onChange={(e) => setNotes2(e.target.value)}
            />
          </div>
          </div>
         
            </>
          )}

<button type="submit" className="reserve-button">
            {editForm ? "Modify Reservation" : "Reserve"}
          </button>

          {editForm && <div onClick={relinquishRoom} className="unreserve-button">
            Cancel Reservation
          </div>}
        </form>
      </div>
    </div>
  );
}

export default ReservationForm;
